<template>
  <xm-modal :show='show'>
    <div slot="title">{{title}}</div>
    <div slot="content">{{message}}</div>
    <div slot="buttons"
         class="xm-modal-buttons">
      <span class="xm-modal-button"
            v-on:click="onClick()">{{okText}}</span>
    </div>
  </xm-modal>
</template>


<script>
import Modal from './Modal';

export default {
  name: 'xm-alert',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: '提示'
    },
    message: {
      type: String,
      required: false,
      default: ''
    },
    okText: {
      type: String,
      required: false,
      default: '确定'
    },
    onOk: {
      type: Function,
      required: false
    }
  },
  components: {
    Modal
  },
  methods: {
    onClick() {
      if (this.onOk) {
        this.onOk();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Alert.vue